<template>
  <div class="sa-dialog" v-show="logoutYes">
    <div class="sa-dialog-body sa-extra-small sa-text-center">
      <p class="sa-mb30">Are you sure want to logout ?</p>
      <button class="sa-btn sa-btn-primary sa-mr20" @click="logout('Log Out')">
        Yes
      </button>
      <button class="sa-btn sa-btn-default" @click="closePopup()">No</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logoutYes: false,
    };
  },
  methods: {
    logout: function (val) {
      this.$emit("logout", val);
    },
    closePopup() {
      this.$parent.logoutYes = false;
    },
  },
};
</script>